module.exports = __webpack_public_path__ + "img/youshi1.68d9e9f8.svg";